import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles({
  table: {
    boxShadow: "none",
    marginBottom: "1.5rem",
  },
  trow: {
    "&:nth-child(even)": {
      backgroundColor: "#f5f5f5",
    },
  },
  thead: {
    color: "white !important",
  },
  tcell: {
    height: "max-content",
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: "16px",
  },
});

const StyledHeadCell = (props) => {
  const classes = useStyles();
  const content = props.content;
  const style = props.style;

  return (
    <TableCell className={classes.thead} style={style}>
      {content}
    </TableCell>
  );
};

const StyledBodyCell = (props) => {
  const classes = useStyles();
  const content = props.content;
  const style = props.style;

  return (
    <TableCell className={classes.tcell} style={style}>
      {content}
    </TableCell>
  );
};

const StyledSkeleton = (props) => {
  const opacity = props.opacity || 1;
  return (
    <div style={{ opacity: opacity }}>
      <Skeleton
        style={{ animationDelay: props.delay + "s" }}
        height={props.height}
      />
    </div>
  );
};

const StyledTable = (props) => {
  const classes = useStyles();
  const headers = props.headers;
  const rows = props.rows;
  const loading = props.loading;

  if (loading) {
    const skeletonHeight = 50;
    const skeletonTotal = 6;
    return (
      <div
        style={{
          paddingTop: "1em",
          paddingLeft: "2em",
          paddingRight: "2em",
        }}
      >
        {[...Array(skeletonTotal).keys()].map((idx) => (
          <StyledSkeleton
            key={idx}
            delay={1 - idx / skeletonTotal}
            height={skeletonHeight}
            opacity={1 - idx / skeletonTotal}
          />
        ))}
      </div>
    );
  }

  return (
    <TableContainer className={classes.table} component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {headers.map((header, hIdx) => (
              <StyledHeadCell
                key={hIdx}
                content={header.content}
                style={header.style}
              />
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rIdx) => (
            <TableRow key={rIdx} className={classes.trow}>
              {row.map((cell, cIdx) => (
                <StyledBodyCell
                  key={cIdx}
                  content={cell.content}
                  style={cell.style}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StyledTable;
